import { SearchableModelHelper } from '~/lib/forms/select';
import * as groupsApis from "../../apis/productGroups";
import * as categoriesApis from "../../apis/productCategories";
import { ProductSegmentType } from '../../consts';


export const createProductSegmentHelper = ({
  segmentType,
  refreshFn,
}: {
  segmentType?: ProductSegmentType;
  refreshFn: () => void;
}) => {
  const isCategory = segmentType === ProductSegmentType.CATEGORY;
  const getById = isCategory ? categoriesApis.getProductCategoryById : groupsApis.getProductGroupById;
  const getList = isCategory ? categoriesApis.getProductCategories : groupsApis.getProductGroups;

  return new SearchableModelHelper(
    refreshFn,
    async (groupId) => {
      const group = await getById(groupId);

      return {
        value: group?.id,
        label: group?.name,
      };
    },
    async (needle) => {
      const groups = await getList({offset: 0, limit: 100 });

      const options = Array.isArray(groups)
        ? groups.map((group) => ({
            value: group.id,
            label: group.name,
          }))
        : [];

      const emptyOption = { value: "", label: `- Without ${isCategory ? "Category" : "Group"} -` };

      return [emptyOption, ...options];
    }
  );
};

